
import { Component, Vue } from 'vue-property-decorator'

export type BranchData = {
  branchId: number
  branchCode: string
  branchName: string
}

export type TeacherData = {
  branch: BranchData
  userId?: number
  acbtCode?: string
  nickname?: string
  password?: string
  passwordConfirmation?: string
  teacherId?: number
}

@Component
export default class TeacherListApis extends Vue {
  /**
   * 教室情報取得
   */
  protected async getBranch(branchId: string): Promise<BranchData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/admin/branches/${branchId}`)
    return data
  }

  /**
   * 塾講師一覧取得
   */
  protected async searchTeacher(branchId: string): Promise<TeacherData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/admin/teachers', {
      params: {
        branchId: branchId,
      },
    })
    return data
  }
  /**
   * エクセルアップロード
   */
  protected async importExcel(branchId: string, file: File): Promise<boolean> {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const params = new FormData()
    params.append('branch_id', branchId)
    params.append('excel', file)
    const { data } = await Vue.prototype.$http.httpWithToken.post('/v1/admin/teacher/import', params, {
      headers: headers,
    })
    return data
  }

  /**
   * エクセル出力
   */
  protected async exportExcel(branchId: string): Promise<{ url: string; filename: string }> {
    let res: { data: Blob } = await Vue.prototype.$http.httpWithToken.get('/v1/admin/teachers/export', {
      params: { branchId: branchId },
      responseType: 'blob',
      dataType: 'binary',
    })
    return {
      url: URL.createObjectURL(res.data),
      filename: '講師一覧.xlsx',
    }
  }

  /**
   * 講師編集取得
   */
  protected async getTeacher(teacherId: string): Promise<TeacherData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/admin/teachers/${teacherId}`)
    return data
  }

  /**
   * 講師新規作成
   */
  protected async createTeacher(teacherData: TeacherData): Promise<void> {
    await Vue.prototype.$http.httpWithToken.post('/v1/admin/users', {
      branchId: teacherData.branch.branchId,
      user: {
        roleType: 'branch',
        nickname: teacherData.nickname,
        password: teacherData.password,
        passwordConfirmation: teacherData.passwordConfirmation,
      },
    })
  }

  /**
   * 講師更新
   */
  protected async updateTeacher(teacherData: TeacherData): Promise<void> {
    let userParams = { nickname: teacherData.nickname }
    if (teacherData.password) {
      userParams['password'] = teacherData.password
      userParams['passwordConfirmation'] = teacherData.passwordConfirmation
    }
    await Vue.prototype.$http.httpWithToken.patch(`/v1/admin/users/${teacherData.userId}`, {
      user: userParams,
    })
  }

  /**
   * ユーザー削除
   */
  protected async deleteUser(userId: string) {
    await Vue.prototype.$http.httpWithToken.delete(`/v1/admin/users/${userId}`)
  }
}
